var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content",attrs:{"id":"content"}},[_c('div',[_c('h1',[_c('router-link',{attrs:{"to":"/admin/stats"}},[_vm._v("Back")])],1)]),_vm._v(" "),_vm._l((_vm.game_stats.os),function(os){return _c('GameOsStatistic',{key:os.name,attrs:{"game_os":os}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c084d72","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/GameStats.vue
// module id = 111
// module chunks = 0